module.exports = __webpack_public_path__ + "img/dentalia.6b899681.png";